import React from 'react';

import { Paragraph } from '@uncinc/react-drupal-core';

import {
  Container,
} from '@uncinc/uncinc-react-kitchen-sink';

import c from 'classnames';

import './style.scss';

const HighlightedItems = ({ entity }) => {
  const caption = entity.getIn(['field_subtitle', 0, 'value']);
  const highlightedItems = entity.getIn(['field_highlighted_paragraph_ref']);
  const flipped = entity.getIn(['field_highlighted_paragraph_ref', 0, 'entity', 'field_flipped', 0, 'value']);

  const highlightedItemsClasses = c('ParagrapHighlighted__highlightedItems', {
    'ParagrapHighlighted__highlightedItems--one': highlightedItems.size === 1,
    'ParagrapHighlighted__highlightedItems--multiple': highlightedItems.size >= 2,
    'ParagrapHighlighted__highlightedItems--one--flipped': highlightedItems.size === 1 && flipped,
  });

  return (
    <Container className="ParagrapHighlighted">
      <div className="row">
        <div className="col-12 col-md-12 col-lg-12 col-xl-12">

          {caption && (
            <div className="ParagrapHighlighted__highlightedItems__caption">
              {caption}
            </div>
          )}

          <div className={highlightedItemsClasses}>
            {highlightedItems && highlightedItems.map((item) => {
              const highlightedItem = item.get('entity');
              const entityId = item.get('target_id');
              return (
                <Paragraph id={entityId} entity={highlightedItem} key={entityId} />
              );
            })}
          </div>
        </div>
      </div>
    </Container>
  );
};

export default HighlightedItems;
